module.exports = __webpack_public_path__ + "assets/img/tech_banner.8ba5f1f8.png";